import { useCallback, useMemo } from 'react';

import { fg } from '@confluence/feature-gating';
import {
	useGetOnboardingState,
	useSetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';
import { SMART_LINK_DRAGGABLE } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

export interface SmartLinkDraggableChangeboardConfig {
	shouldShow: boolean;
	onClose: () => void;
}

export const useSmartLinkDraggableChangeboardConfig = (): SmartLinkDraggableChangeboardConfig => {
	const { data: onboardingStateData } = useGetOnboardingState(
		[SMART_LINK_DRAGGABLE.CHANGEBOARD_VIEWED],
		!fg('cc_drag_and_drop_smart_link_from_content_to_tree'),
	);
	const deserializedState = deserializeState(onboardingStateData);
	const changeboardViewed = deserializedState[SMART_LINK_DRAGGABLE.CHANGEBOARD_VIEWED];

	const { setOnboardingState } = useSetOnboardingState();

	const onClose = useCallback(async () => {
		await setOnboardingState({
			key: SMART_LINK_DRAGGABLE.CHANGEBOARD_VIEWED,
			value: 'true',
		});
	}, [setOnboardingState]);

	const shouldShow =
		fg('cc_drag_and_drop_smart_link_from_content_to_tree') && changeboardViewed !== true;

	return useMemo(
		() => ({
			shouldShow,
			onClose,
		}),
		[shouldShow, onClose],
	);
};
